export const PROJECT_STATUS_COLORS = {
  "Not Started": "bg-neutral-100 border-neutral-300 text-neutral-700",
  "In Progress": "bg-blue-500/15 border-blue-500/30 text-blue-700",
  "On Hold": "bg-yellow-500/15 border-yellow-500/30 text-yellow-700",
  "Completed": "bg-emerald-500/15 border-emerald-500/30 text-emerald-700",
  "Cancelled": "bg-rose-500/15 border-rose-500/30 text-rose-700",
};

export const PRIORITY_COLORS = {
  "Low": "bg-neutral-100 border-neutral-300 text-neutral-700",
  "Medium": "bg-blue-500/15 border-blue-500/30 text-blue-700",
  "High": "bg-orange-500/15 border-orange-500/30 text-orange-700",
  "Critical": "bg-rose-500/15 border-rose-500/30 text-rose-700",
};

export const REQ_STATUS_COLORS = {
  "Draft": "bg-neutral-100 border-neutral-300 text-neutral-700",
  "Under Review": "bg-yellow-500/15 border-yellow-500/30 text-yellow-700",
  "Approved": "bg-emerald-500/15 border-emerald-500/30 text-emerald-700",
  "Rejected": "bg-rose-500/15 border-rose-500/30 text-rose-700",
  "Completed": "bg-blue-500/15 border-blue-500/30 text-blue-700",
};

export const TASK_STATUS_COLORS = {
  "To Do": "bg-neutral-100 border-neutral-300 text-neutral-700",
  "In Progress": "bg-blue-500/15 border-blue-500/30 text-blue-700",
  "Under Review": "bg-purple-500/15 border-purple-500/30 text-purple-700",
  "Blocked": "bg-rose-500/15 border-rose-500/30 text-rose-700",
  "Completed": "bg-emerald-500/15 border-emerald-500/30 text-emerald-700",
};

export const APPROVAL_COLORS = {
  "Pending": "bg-yellow-500/15 border-yellow-500/30 text-yellow-700",
  "Approved": "bg-emerald-500/15 border-emerald-500/30 text-emerald-700",
  "Rejected": "bg-rose-500/15 border-rose-500/30 text-rose-700",
};

export const TASK_STATUSES = ["To Do", "In Progress", "Under Review", "Blocked", "Completed"];
export const REQ_STATUSES = ["Draft", "Under Review", "Approved", "Rejected", "Completed"];
export const PROJECT_STATUSES = ["Not Started", "In Progress", "On Hold", "Completed", "Cancelled"];
export const PRIORITIES = ["Low", "Medium", "High", "Critical"];
export const PROJECT_TYPES = ["Website", "Mobile App", "Web Application", "Software", "Other"];
